import Testimony1 from '../assets/images/testimony1.png';
import Testimony2 from '../assets/images/testimony2.png';
import Testimony3 from '../assets/images/testimony3.png';
import Testimony4 from '../assets/images/testimony4.png';
import Testimony5 from '../assets/images/testimony5.jpg';

export default [
  {
    img: Testimony2,
    name: 'Bimbo',
    role: 'Business Development Manager',
    testimony: 'I attended talent acquisition programme and it helped broaden my horizon. I can’t wait to be back to learn more at Purple Academy.'
  },
  {
    img: Testimony1,
    name: 'Chinecherem',
    role: 'Legal',
    testimony: 'Indeed, I can say that I graduated from purple academy with experiences, learnings and nuggets that has contributed to my overall individual and professional growth.'
  },
  {
    img: Testimony3,
    name: 'Chidinma',
    role: 'Information Security',
    testimony: 'It was a great experience.. one I won’t forget.. stressful with the intensive learning.. bonded with strangers and made a family off them.. and experience I won’t forget soon.'
  },
  {
    img: Testimony4,
    name: 'Temitope Ogundeji',
    role: 'Head. Casa Investment',
    testimony: 'The Balance Score card training was quite enlightening and it has broaden my horizon on how to enhance my targets more efficiently and also the increased knowledge of how to handle performance management.'
  },
  {
    img: Testimony5,
    name: 'Dominic Oko',
    role: 'Zonal Service Manager',
    testimony: 'The Balance Score Card training was quite enriching and timely. I am now more empowered to handle performance management better and cascade organizational goals more effectively. The training added value. Thank you.'
  }
];
